import React, { FC } from 'react';
import logo from '../../assets/logo.png';
import styles from './styles.module.scss';

const Header: FC = () => {
    return (
        <header className={styles.header}>
            <img src={logo} alt='' />
        </header>
    );
};

export default Header;
